module.exports = (__webpack_require__("wdOX"))(53);


//////////////////
// WEBPACK FOOTER
// delegated ../annotation-plugin-json-preview/es/index.js from dll-reference AnnotationStudioPlugins
// module id = ceUH
// module chunks = 0